import React, {useContext, useState} from 'react';
import {useNavigate} from "react-router-dom";
import Slick from "react-slick";
import {Grid2 as Grid, Paper, Typography} from "@mui/material";
import __placeListItemSlick from "../../places/placesList/__placeListItemSlick";
import {gym_query} from "../../../network/api/gym.api";
import {ErrorContext} from "../../../components/GympinPagesProvider";
import _epCarouselGymList from "./carousels/_epCarouselGymList";
import _epCarouselIncredibleList from "./carousels/_epCarouselIncredibleList";
import _epCarouselCounselingList from "./carousels/_epCarouselCounselingList";
import _epCarouselButtonList from "./carousels/_epCarouselButtonList";

const _epCarousel = (carousel) => {





    switch (carousel?.Description){
        case "BUTTON_LIST": return <_epCarouselButtonList carousel={carousel} />
        case "QUERY_LIST_GYMS": return <_epCarouselGymList carousel={carousel} />
        // case "INCREDIBLE_GYMS": return <_epCarouselIncredibleList />
        // case "QUERY_Counselings": return <_epCarouselCounselingList />
    }
};

export default _epCarousel;
